import React, { useState } from 'react';
import { square_photo } from '../../assets/index';
import { postStudentEnquiry } from '../../services/getAllApi';
import { PursueMBA1, PursueMBA2, PursueMBA3, PursueMBA4 } from '../../assets/index';

const FeatureBox = ({ image, title, subtitle, index }) => {
  const [isHovered, setIsHovered] = useState(false);

  const getLayoutClass = () => {
    switch (index % 4) {
      case 0:
        return 'bg-gradient-to-r from-orange-300 to-purple-200 hover:from-purple-300 hover:to-orange-300 transition-all duration-500';
      case 1:
        return 'bg-gradient-to-r from-blue-300 to-yellow-400 hover:from-yellow-300 hover:to-blue-300 transition-all duration-500';
      case 2:
        return 'bg-gradient-to-r from-pink-400 to-green-200 hover:from-green-400 hover:to-pink-300 transition-all duration-500';
      case 3:
        return 'bg-gradient-to-r from-red-300 to-blue-300 hover:from-blue-300 hover:to-red-300 transition-all duration-500';
      default:
        return 'bg-gray-50';
    }
  };


  return (
    <div
      className={`group relative overflow-hidden rounded-2xl transition-all duration-300 ${getLayoutClass()} 
        transform ${isHovered ? 'scale-105' : ''} hover:shadow-xl
        w-full h-full min-h-[12rem] p-6`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="absolute top-0 right-0 w-32 h-32 -mr-16 -mt-16 bg-white/30 rounded-full transform rotate-45" />

      <div className="relative z-10 h-full flex flex-col">
        <div className="flex items-start mb-4">
          <img
            src={image}
            alt={title}
            className={`w-12 h-12 object-contain transition-all duration-300 ${isHovered ? 'scale-110' : ''
              }`}
          />
        </div>

        <h3 className="text-lg font-semibold mb-2 transition-all duration-300 group-hover:text-gray-800">
          {title}
        </h3>

        {subtitle && (
          <p className="text-sm text-gray-600 mt-auto transition-all duration-300 group-hover:text-gray-700">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};
const handleDownload = () => {
  const link = document.createElement("a");
  link.href = "/FBS Guaranteed Job MBA 2025.pdf"; // Ensure it's inside 'public' folder
  link.download = "FBS-Brochure.pdf"; // Sets the download filename
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const WhyFBS = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email_address: '',
    contact_number: '',
    course_interested: '',
    city: '',
    agree: false,
    more_info: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });


    if (!formData.first_name || !formData.last_name || !formData.email_address ||
      !formData.contact_number || !formData.course_interested || !formData.city ||
      !formData.agree) {
      setError('Please fill in all fields and agree to the terms.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await postStudentEnquiry(formData);
      if (response.status === 201 || response.status === 200) {
        setSuccessMessage('Your request has been successfully submitted!');
        setFormData({
          first_name: '',
          last_name: '',
          email_address: '',
          contact_number: '',
          course_interested: '',
          city: '',
          more_info: '',
          agree: false
        });
      } else {
        setError(JSON.stringify(response.response.data.message));
      }
    } catch (error) {
      setError('An error occurred while submitting the form.');
    } finally {
      setLoading(false);
    }
  };

  const features = [
    {
      image: PursueMBA1,
      title: "Affordable MBA Pursuit at Dr. D.Y. Patil Vidyapeeth",
      subtitle: "UGC recognized & NAAC, AICTE, ASSOCHAM, AIU, & WES accredited."
    },
    {
      image: PursueMBA2,
      title: "Corporate Industry Recognized 15+ Core Finance Certifications"
    },
    {
      image: PursueMBA3,
      title: "Obtain 1 year Job experience in Finance recognized by FINXL BUSINESS SCHOOL"
    },
    {
      image: PursueMBA4,
      title: "Transforming students into business management professionals"
    }
  ];

  return (
    <div className="relative w-full">
      {/* Features Section */}
      <div className="w-full px-4 sm:px-6 lg:px-8 pb-8">
        <div className="w-full px-2 sm:px-4 md:px-6 lg:px-8 mt-16 sm:mt-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {features.map((feature, index) => (
              <FeatureBox
                key={index}
                index={index}
                image={feature.image}
                title={feature.title}
                subtitle={feature.subtitle}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Content Section with Image and Form */}
      <div className="relative lg:left-[7rem] w-full flex flex-col lg:flex-row items-center justify-between px-4 lg:px-8">
        {/* Image */}
        <div className="w-full lg:w-1/2">
          <img
            src={square_photo}
            alt="Square Photo"
            className="w-72 h-72 md:w-96 md:h-96 lg:w-[37rem] lg:h-[37rem] mx-auto lg:mx-0"
          />
        </div>

        {/* Form */}
        <div className="w-full lg:w-[30%] relative lg:right-[20rem] bg-white/60 text-black shadow-lg rounded-lg p-8">
          <h3 className="text-2xl font-bold mb-6 text-orange-500">Enter Details</h3>
          <form onSubmit={handleSubmit} >
            <div className="grid gap-[0.6rem] relative bottom-[1rem]">
              <div className="flex gap-4  ">
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  placeholder="First Name"
                  className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                />
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Last Name"
                  className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                />
              </div>
              <input
                style={{ width: '100%', padding: '0.5rem' }}
                type="tel"
                name="contact_number"
                value={formData.contact_number}
                onChange={handleChange}
                placeholder="Phone No. +91"
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              />
              <input
                type="email_address"
                name="email_address"
                value={formData.email_address}
                onChange={handleChange}
                placeholder="Email"
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              />
              <select
                name="course_interested"
                value={formData.course_interested}
                onChange={handleChange}
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              >
                <option value="" disabled>Course Interested</option>
                <option value="MBA in Finance">MBA in Finance</option>
              </select>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="City"
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              />
              <input
                type="text"
                name="more_info"
                value={formData.more_info}
                onChange={handleChange}
                placeholder="More Info"
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              />
              <div className="flex flex-col items-start gap-4">
                <p className="text-left text-gray-600 text-[0.6rem]">
                  By clicking the button below, you agree to receive communications via email/Call/WhatsApp/SMS from FBS-FINXL Business School.
                </p>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="agree"
                    name="agree"
                    checked={formData.agree}
                    onChange={handleChange}
                    className="w-4 h-4 text-orange-500 border-gray-300 rounded focus:ring-orange-500"
                  />
                  <label htmlFor="agree" className="text-[0.7rem] text-gray-600 text-left cursor-pointer">
                    I have read and agree to FBS's <a href="/terms" className="text-orange-500 underline">terms & conditions</a>.
                  </label>
                </div>
              </div>
              {error && <p className="text-red-500">{error}</p>}
              {successMessage && <p className="text-green-500">{successMessage}</p>}

              <div className="downloadB">
                <div class="wrapper">
                  <a onClick={handleDownload} class="c-btn">
                    <span class="c-btn__label">BROCHURE 
                      <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                        </path>
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
              <div>
                <button
                  type="submit"
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-md"
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default WhyFBS;